import * as ApiManager from "../_manager";

export const adminUser = {
  list: (payload = null) => {
    return ApiManager.callApi("/admin/user/list", payload);
  },

  deleteUserDetails: (payload) => {
    return ApiManager.callApi("/admin/user/deleteUserDetails", payload);
  },
};
